module.exports = __webpack_public_path__ + "img/mianoura_logo.54761014.jpeg";